import React, { useEffect, useState } from 'react';
import Modal from '@/components/Modal/Modal';
import styles from './TermsModal.module.css';
import { getTermsHtml } from '@/services/api';

export default function TermsModal({
  open,
  onClose,
  title,
  loadingMessage,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  loadingMessage: string;
}) {
  const [html, setHtml] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open || html !== null) return;
    let cancelled = false;

    setError(null);

    getTermsHtml()
      .then((text) => {
        if (!cancelled) setHtml(text);
      })
      .catch(() => {
        if (!cancelled) setError('Failed to load Terms and Conditions.');
      });

    return () => {
      cancelled = true;
    };
  }, [open, html]);

  return (
    <Modal isOpen={open} onClose={onClose} title={title}>
      {error && <p className={styles.error}>{error}</p>}
      {!error && (
        <div
          className={styles.scroll}
          dangerouslySetInnerHTML={{ __html: html ?? `<p>${loadingMessage}</p>` }}
        />
      )}
    </Modal>
  );
}
